import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Quotes from './pages/Quotes';
import Admin from './pages/Admin';
import QuoteDetail from './pages/QuoteDetail';
import DbSchema from './pages/DbSchema';
import ClaudeAnalyzer from './pages/ClaudeAnalyzer';
import About from './pages/About';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import Policies from './pages/Policies';
import PolicyDetail from './pages/PolicyDetail';
import Opinions from './pages/Opinions';
import OpinionDetail from './pages/OpinionDetail';
import PoliciesAdmin from './pages/admin/PoliciesAdmin';
import AddPolicy from './pages/admin/AddPolicy';
import EditPolicy from './pages/admin/EditPolicy';
import OpinionsAdmin from './pages/admin/OpinionsAdmin';
import AddOpinion from './pages/admin/AddOpinion';
import EditOpinion from './pages/admin/EditOpinion';
import Navigation from './components/Navigation';
import { MobileNavigation } from './components/mobile';
import ToastContainer from './components/ToastContainer';

function App() {
  // Add debugging for component rendering
  useEffect(() => {
    console.log('[App] Component mounted');
    
    // Check if we're on mobile
    const isMobile = window.innerWidth < 640;
    console.log('[App] Is mobile device:', isMobile);
    
    // Debug mobile touch handling
    if (isMobile) {
      console.log('[App] Adding debug touch listeners');
      document.addEventListener('touchstart', () => {
        console.log('[App] touchstart event fired');
      });
      document.addEventListener('click', () => {
        console.log('[App] click event fired');
      });
    }
    
    return () => {
      if (isMobile) {
        document.removeEventListener('touchstart', () => {});
        document.removeEventListener('click', () => {});
      }
      console.log('[App] Component unmounted');
    };
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-white">
          <Navigation />
          {/* Updated container div to work with mobile layout */}
          <div className="pt-16 px-4 sm:px-6 lg:px-8 mobile-content-container pb-16">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about.html" element={<About />} />
              {/* Quotes routes */}
              <Route path="/q" element={<Quotes />} />
              <Route path="/q/" element={<Quotes />} />
              {/* Support different quote URL formats with 301 redirects in catchall.js */}
              <Route path="/quote/:id" element={<QuoteDetail />} />
              <Route path="/q/:id.html" element={<QuoteDetail />} />
              {/* New slugged format */}
              <Route path="/q/:id/:slug.html" element={<QuoteDetail />} />
              {/* Articles routes */}
              <Route path="/a" element={<Articles />} />
              <Route path="/a/" element={<Articles />} />
              <Route path="/articles" element={<Articles />} /> {/* Keep this for backward compatibility */}
              <Route path="/a/:id/:slug.html" element={<ArticleDetail />} />
              {/* Policy routes */}
              <Route path="/p" element={<Policies />} />
              <Route path="/p/" element={<Policies />} />
              <Route path="/policies" element={<Policies />} /> {/* For backward compatibility */}
              {/* Route with ID at the end of the slug */}
              <Route path="/p/:slug.html" element={<PolicyDetail />} />
              {/* Opinions routes */}
              <Route path="/o" element={<Opinions />} />
              <Route path="/o/" element={<Opinions />} />
              <Route path="/opinions" element={<Opinions />} /> {/* For consistency */}
              <Route path="/o/:slug.html" element={<OpinionDetail />} />
              {/* Admin routes */}
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/claude-analyze" element={<ClaudeAnalyzer />} />
              {/* Policy admin routes */}
              <Route path="/admin/policies" element={<PoliciesAdmin />} />
              <Route path="/admin/policies/add" element={<AddPolicy />} />
              <Route path="/admin/policies/:id/edit" element={<EditPolicy />} />
              {/* Fallback route for direct policy ID access */}
              <Route path="/admin/policies/:id" element={<EditPolicy />} />
              {/* Opinion admin routes */}
              <Route path="/admin/opinions" element={<OpinionsAdmin />} />
              <Route path="/admin/opinions/add" element={<AddOpinion />} />
              <Route path="/admin/opinions/:id/edit" element={<EditOpinion />} />
              {/* Utility routes */}
              <Route path="/db-schema" element={<DbSchema />} />
            </Routes>
          </div>
          {/* Mobile Navigation - with higher z-index and direct DOM attachment */}
          <div id="mobile-nav-container" className="z-[9999]">
            <MobileNavigation key="mobile-navigation" />
          </div>
          <ToastContainer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;